export default __webpack_public_path__ + "static/car6-e7b7ae4035743f6b7c0dd209752facd4.glb";